import { createFileRoute, stripSearchParams } from "@tanstack/react-router"
import { useCallback } from "react"
import { CompanyListPage } from "@/components/pages/companies/list"
import { useTabNavigation } from "@/hooks/use-tab-navigation"
import { useUrlSearch } from "@/hooks/use-url-search"
import { companiesSearchSchema } from "@/lib/schemas/companies"

export type CompanyTab = "customers" | "leads" | "prospects"

const tabSearchReset = { q: "" } as const

export const Route = createFileRoute("/_authenticated/companies/")({
	validateSearch: companiesSearchSchema,
	search: {
		middlewares: [stripSearchParams(companiesSearchSchema.parse({}))],
	},
	component: CompanyListRoute,
})

function CompanyListRoute() {
	const { tab: tabSearch, q } = Route.useSearch()
	const navigate = Route.useNavigate()
	const { tab, onTabChange } = useTabNavigation<CompanyTab>(
		navigate,
		"customers",
		tabSearch,
		tabSearchReset,
	)

	const onUrlSearchChange = useCallback(
		(value: string) => {
			navigate({
				search: (prev) => ({ ...prev, q: value }),
				replace: true,
				resetScroll: false,
			})
		},
		[navigate],
	)

	const [searchValue, setSearchValue] = useUrlSearch(q, onUrlSearchChange)

	return (
		<CompanyListPage
			tab={tab}
			onTabChange={onTabChange}
			search={searchValue}
			onSearchChange={setSearchValue}
		/>
	)
}
